require('./hireCreditCardView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { FormattedText, formatText, getFinalTitle, hasTranslation } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCreditCardActions = require('actions/hireCreditCard');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const shippingAddressAction = require('actions/shippingAddress');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const HireCreditCardStep1 = require('components/hire/creditCard/hireCreditCardStep1/hireCreditCardStep1');
const HireCreditCardStep2 = require('components/hire/creditCard/hireCreditCardStep2/hireCreditCardStep2');
const HireCreditCardStep3 = require('components/hire/creditCard/hireCreditCardStep3/hireCreditCardStep3');
const HireCreditCardStep4 = require('components/hire/creditCard/hireCreditCardStep4/hireCreditCardStep4');
const HireCreditCardStep5 = require('components/hire/creditCard/hireCreditCardStep5/hireCreditCardStep5');
const HireCreditCardSuccess = require('components/hire/creditCard/hireCreditCardSuccess/hireCreditCardSuccess');
const HireCreditCardError = require('components/hire/creditCard/hireCreditCardError/hireCreditCardError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const { HireCardOpenCreditStepINEDIR } = require('components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
  REDIRECT_URL,
  THIRD_STEP,
  WIZARD_FIRST_STEP,
  WIZARD_SECOND_STEP,
} = require('constants/index');
const { HIRE_CARD_OPEN_CREDIT } = require('constants/operationCodesAccounts');
const {
  CREDIT_CARD_REVOLVING_PROCESS,
  LIMIT_CREDIT_CARD,
  WEB_INACTIVE_ACCOUNT_ENABLED,
  ES_COUNTRY,
  MESSAGE_HIRE_24H,
  NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const {
  catalogue,
  analyticsId,
} = require('components/hire/cardNeruda/analytics/hireCardNerudaViewAnalytics');

// @utilities
import { getCardData, navigateBasedOnCardType, getPlacementIdCard, getServiceCodes, getHireCmsKey } from './hireCreditCardViewUtilities';

class HireCreditCardView extends React.Component {
  constructor(props) {
    super(props);

    const { cardType, immFlagBasedFeatures, immProfile, history } = props;
    navigateBasedOnCardType(cardType, history, immFlagBasedFeatures, immProfile, this.hasCardOfType);
    props.setDataNerudaCard(getCardData(cardType));
    this.placementIdCard = getPlacementIdCard(cardType);
    this.serviceCodes = getServiceCodes(cardType);
    this.getHireCmsKey = getHireCmsKey(cardType).hireCmsKey;
    this.collectiveLocation = getHireCmsKey(cardType).collectiveLocation;
    this.contractPdfData = getHireCmsKey(cardType).contractPdfData;
    this.getContextTranslate = this.getContextTranslate.bind(this);
    this.getContextKeyTranslate = this.getContextKeyTranslate.bind(this);
    this.isReady = this.isReady.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleAccountChange = this.handleAccountChange.bind(this);
  }

  componentDidMount() {
    const {
      getBlockedAccounts,
      getshippingAddressList,
      immAccounts,
      setCardType,
      cardType,
      match: {
        params: { redirect },
      },
      resetPrecontractualDocumentMail,
      validateStep,
    } = this.props;
    resetPrecontractualDocumentMail();
    if (redirect === REDIRECT_URL) {
      validateStep(WIZARD_FIRST_STEP);
    }
    getshippingAddressList();
    setCardType(cardType)
    getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_CREDIT);
  }

  componentWillUnmount() {
    const { reset, resetBlockedAccounts, resetPrecontractualMail, resetTermsAndCondsText, } =
      this.props;

    reset();
    resetBlockedAccounts();
    resetTermsAndCondsText();
    if (__CONTACT_CENTER__) resetPrecontractualMail();
  }

  buildConfirmationLabel(labels) {
    const labelElements = labels.map(item => {
      let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
      let url;

      const href = item.href;
      url = hasTranslation(href) ? formatText(href) : href;

      if (url) {
        element = (
          <OKLink
            key={item.text}
            id={item.id}
            target="_blank"
            to={url}
            modifier="emphasize"
            onClick={() => recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text))}
          >
            {element}
          </OKLink>
        );
      }

      return element;
    });

    return labelElements;
  }
  getProcessDetail() {
    const { hireCreditCard } = this.props;
    const processDetails = hireCreditCard.get('cards').toJS().map(card => `${card.type}.${card.subtype}`);
    return processDetails.length > 0 ? processDetails[0] : '';
  }

  handleCancel() {
    this.props.history.push('/myprofile/cards');
  }

  handleAccountChange(accountId) {
    const { handleAccountChange, resetPrintDocument, checkRadioButton, resetEmailAndRadioButtonCC } = this.props;
    handleAccountChange(accountId);
    __CONTACT_CENTER__ && resetEmailAndRadioButtonCC();

    if (isPrintOfficeMode()) {
      resetPrintDocument();
      checkRadioButton(undefined);
    }
  }

  buildINE() {
    const { hireCreditCard, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardNerudaPrintDocument } = this.props;
    const documentINE = hireCreditCard.get('documentINE')
    const scrollDown = hireCreditCard.get('scrollDown')
    const agreeIneCheckbox = hireCreditCard.get('agreeIneCheckbox')
    const checkButtonRadio = hireCreditCard.get('checkButtonRadio')
    const printDocument = hireCreditCard.get('printDocument')
    const documentsPrintedAndSigned = hireCreditCard.get('cardsDocumentsPrintedAndSigned')

    return (
      <HireCardOpenCreditStepINE
        documentINE={documentINE}
        cardsConfimationScrollDown={cardsConfimationScrollDown}
        scrollDown={scrollDown}
        checkCheckedDocument={checkCheckedDocument}
        agreeIneCheckbox={agreeIneCheckbox}
        printedAndSignedRadioChanged={printedAndSignedRadioChanged}
        enableButtonOffice={enableButtonOffice}
        checkRadioButton={checkRadioButton}
        checkButtonRadio={checkButtonRadio}
        hireCardOpenCreditprintDocument={hireCardNerudaPrintDocument}
        printDocument={printDocument}
        immPrinter={immPrinter}
        documentsPrintedAndSigned={documentsPrintedAndSigned}
      />
    );
  }
  buildINEDIR() {
    const { hireCreditCard, documentRead, onAcceptAllDocument, saveDocumentList, checkRadioButtonIneDir } = this.props;
    const initialDocumentsList = hireCreditCard.get('initialDocumentsList')
    const acceptedDocument = hireCreditCard.get('acceptedDocument')
    const precontractualConfirmationLabel = [
      {
        text: 'hireCreditCard-textInfoIneDir'
      },
      {
        text: 'hireCreditCard-textLinkInfoIneDir',
        href: 'hireCreditCard-linkInfoIneDir'
      },

    ]
    const precontractualLabel = this.buildConfirmationLabel(precontractualConfirmationLabel)
    const allDocumentRead = hireCreditCard.get('allDocumentRead')

    return (
      <HireCardOpenCreditStepINEDIR
        initialDocumentList={initialDocumentsList}
        onSavedocumentAcceptance={documentRead}
        acceptedDocument={acceptedDocument}
        onAcceptAllDocument={onAcceptAllDocument}
        precontractualLabel={precontractualLabel}
        allDocumentRead={allDocumentRead}
        saveDocumentList={saveDocumentList}
        checkRadioButtonIneDir={checkRadioButtonIneDir}
      />
    );
  }
  isReady() {
    const { hireCreditCard } = this.props;
    let showPreLeaveModal = true;

    if (hireCreditCard.get('visibleStep') === 1) {
      showPreLeaveModal = false;
    }

    return showPreLeaveModal;
  }

  getContextTranslate(translate) {
    const { cardType } = this.props;
    let context = '';
    switch (cardType) {
      case 'neruda':
        context = `hireCardNeruda-hireCardNeruda_`;
        break;
      case 'vanity':
        context = `hireCardVanity-hireCardVanity_`;
        break;
      case 'hormiguero':
        context = `hireCardNeruda-hireCardNeruda_`;
        break;
      case 'diamond':
        context = `hireCardDiamondPack-`;
        break;
      case 'open-credit':
        context = `hireCardOpenCredit-`;
        break;
      case 'premium':
        context = `hireCardPremiumPack-`;
        break;
    }

    return `${context}${translate}`;
  }

  getContextKeyTranslate(translate) {
    const { cardType } = this.props;
    const cardTypeMap = {
      'neruda': {
        step2Informative: 'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoMsgNeruda',
        step2Emphasize: 'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoLinkTextNeruda',
        errorTitleGeneric: 'disclaimerPersonalInfo-errorTitleGeneric',
        errorTextGeneric: 'errorTextGeneric',
        errorTitle: 'hireCardNeruda-errorTitleLowCreditScore_updated',
        errorTextElement1: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_2',
        context: 'disclaimerPersonalInfo-'
      },
      'vanity': {
        step2Informative: 'hireCardVanity-hireCardVanity_disclaimerPersonalInfoMsgNeruda',
        step2Emphasize: 'hireCardVanity-hireCardVanity_disclaimerPersonalInfoLinkTextNeruda',
        errorTitleGeneric: 'disclaimerPersonalInfo-errorTitleGeneric',
        errorTextGeneric: 'errorTextGeneric',
        errorTitle: 'hireCardNeruda-errorTitleLowCreditScore_updated',
        errorTextElement1: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_2',
        context: 'disclaimerPersonalInfo-'
      },
      'hormiguero': {
        step2Informative: 'hireCardVanity-hireCardVanity_disclaimerPersonalInfoMsgNeruda',
        step2Emphasize: 'hireCardVanity-hireCardVanity_disclaimerPersonalInfoLinkTextNeruda',
        errorTitleGeneric: 'disclaimerPersonalInfo-errorTitleGeneric',
        errorTextGeneric: 'errorTextGeneric',
        errorTitle: 'hireCardNeruda-errorTitleLowCreditScore_updated',
        errorTextElement1: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_2',
        context: 'disclaimerPersonalInfo-'
      },
      'diamond': {
        step2Informative: 'disclaimerPersonalInfo-diamondPackMsg',
        step2Emphasize: `disclaimerPersonalInfo-diamondPackLinkText`,
        errorTitleGeneric: `errorTitleGeneric`,
        errorTextGeneric: `errorTextGeneric`,
        errorTitle: 'hireCardDiamondPack-errorTitleLowCreditScoreUpdated',
        errorTextElement1: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_2',
        context: `hireCardDiamondPack-`,
      },

      'open-credit': {
        step2Informative: 'disclaimerPersonalInfo-visaOpenMsg',
        step2Emphasize: `disclaimerPersonalInfo-visaOpenLinkText`,
        errorTitleGeneric: `disclaimerPersonalInfo`,
        errorTextGeneric: `errorTextGeneric`,
        errorTitle: 'hireCardDiamondPack-errorTitleLowCreditScoreUpdated',
        errorTextElement1: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_2',
      },
      'premium': {
        step2Informative: 'disclaimerPersonalInfo-premiumPackMsg',
        step2Emphasize: `disclaimerPersonalInfo-premiumPackLinkText`,
        errorTitleGeneric: `disclaimerPersonalInfo`,
        errorTextGeneric: `errorTextGeneric`,
        errorTitle: 'hireCardDiamondPack-errorTitleLowCreditScoreUpdated',
        errorTextElement1: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_1',
        errorTextElement2: 'hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_2',
      }

    };

    const cardInfo = cardTypeMap[cardType] || {};
    return cardInfo[translate];
  }
  buildSuccessful() {
    const {
      immAccounts,
      immHireCardImageSelector,
      immHireCardNameSelector,
      hireCreditCard,
      immHireCreditLimit,
      immHirePaymentMethod,
      immProfile,
      immShippingAddressList,
      cardType
    } = this.props;
    const selectedAccount = hireCreditCard.getIn(['steps', THIRD_STEP, 'accountId']);
    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
    const immShippingAddress = immShippingAddressList.get('shippingAddress');
    const EXTRA_IMAGE = cardType === 'diamond' && 'B.506.008.003';

    const processDetail = this.getProcessDetail();

    return (
      <div className="col-xs-12 col-md-offset-1 col-md-10">
        <HireCreditCardSuccess
          getContextTranslate={this.getContextTranslate}
          immAccount={immAccount}
          hireCreditCard={hireCreditCard}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNameSelector={immHireCardNameSelector}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          immProfile={immProfile}
          immShippingAddress={immShippingAddress}
          processDetail={processDetail}
          extraImage={EXTRA_IMAGE}
        />
      </div>
    );
  }

  getCardTypeString(cardType) {
    switch (cardType) {
      case 'diamond':
        return 'diamond';
      case 'open-credit':
        return 'open-credit';
      case 'via-t':
        return 'via-t';
      case 'premium':
        return 'premium';
      default:
        return 'open-credit';
    }
  }
  areRequiredFieldsValid(newContactData) {
    const requiredFields = ['number', 'others', 'population', 'postalCode', 'province', 'roadName'];
    return requiredFields.every(field => newContactData[field].isValid);
  }
  buildWizardHiringSteps() {
    const {
      cardType,
      handleAccountChange,
      handleAgreementCheckboxChange,
      immAccounts,
      immFlagBasedFeatures,
      immGlobalVariables,
      immHireCardImageSelector,
      immHireCardNameSelector,
      hireCreditCard,
      immHireContactData,
      immHireCreditLimit,
      immHireInformation,
      immHirePaymentMethod,
      immProfile,
      immShippingAddressList,
      immPdfData,
      requestPDFDownload,
      requestPDFMerge,
      sendPrecontractualDocumentMail,
      setAllAccountsToInactive,
      setHireCreditLimit,
      setShippingAddress,
      setTermsAndCondsText,
      setVisibleStep,
      setWillCancel,
      toggleCreditLimitModal,
      validate,
      validateStep,
      immRevolvingPersistentData,
      onHandleChangeCheckBoxCC,
      myCardsTarjetasHire,
      hireCardOpenCreditprintDocument,
      cardsConfimationScrollDownPolicy,
      hireCardNerudaPrintDocumentPolicy,
      hireCardNerudaPrintDocument,
      printedAndSignedRadioChanged,
      enableButtonOffice,
      checkRadioButtonPolicy,
      getInitCardsDocuments,
      processEmail,
    } = this.props;
    const hireCmsKey = this.getHireCmsKey;
    const collectiveLocation = this.collectiveLocation;
    const contractPdfData = this.contractPdfData;
    const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
    const showPreLeaveModal = this.isReady();
    const documentsPrintedAndSigned = hireCreditCard.get('cardsDocumentsPrintedAndSigned');

    const wizardActions = {
      cancel: this.handleCancel,
      finish: myCardsTarjetasHire,
      setVisibleStep,
      setWillCancel,
      validateStep,
    };

    let immSteps = !isPrintOfficeMode() && __CONTACT_CENTER__ ? hireCreditCard.get('steps').splice(4, 1) : hireCreditCard.get('steps');
    const visibleStep = hireCreditCard.get('visibleStep')
    const sendMailParams = {
      type: hireCreditCard.get('type'),
      subType: hireCreditCard.get('subtype'),
      standar: hireCreditCard.get('standard'),
    };
    const immShippingAddress = immShippingAddressList.get('shippingAddress');
    const newShippingAddress = immShippingAddress.toJS();
    const isNewShippingAddress = Object.keys(newShippingAddress).length === 0;
    const filledNewContactData = immHireContactData.toJS();
    const isNewShippingAddressButtonDisabled = this.areRequiredFieldsValid(filledNewContactData);
    const hasShippingAddress = true;
    const nextButtonDisabledStep2 =
      immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
    const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    const agreeIneCheckbox = hireCreditCard.get('agreeIneCheckbox')
    const checkButtonRadio = hireCreditCard.get('checkButtonRadio')
    const allDocumentRead = hireCreditCard.get('allDocumentRead')
    const errorDir = hireCreditCard.get('errorDir')

    const productName = this.getProcessDetail();
    const tealiumData = [
      catalogue[analyticsId.NERURA_CARD_STEP_1_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_2_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_3_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_4_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_5_VIEW]({ productName }),
    ];

    const isShippingAddressButtonDisabled =
      !!immShippingAddressList &&
      !immShippingAddressList.get('shippingAddressType') &&
      immFlagBasedFeatures.get(ES_COUNTRY);
    const loadingFlag = hireCreditCard.get('loadingFlag');
    const checkboxChecked = hireCreditCard.get('agreeIneCheckbox')
    const newFinalButtonDisabledCC = checkboxChecked || !allDocumentRead
    const EXTRA_IMAGE = cardType === 'diamond' && 'B.506.008.003';

    const commonSteps = [
      <WizardStep cancelButton={true} position="first" isLoading={loadingFlag}>
        <WebappRender>
          <HireCreditCardStep1
            cardType={cardType}
            getContextTranslate={this.getContextTranslate}
            hireCmsKey={hireCmsKey}
            immFlagBasedFeatures={immFlagBasedFeatures}
            hireCreditCard={hireCreditCard}
            immHireInformation={immHireInformation}
            requestPDFMerge={requestPDFMerge}
            showIneAndRevolving={showIneAndRevolving}
            collectiveLocation={collectiveLocation}
            newCardsFF={newCardsFF}
            contractPdfData={contractPdfData}
          />
        </WebappRender>
        <ContactCenterRender>
          <HireCreditCardStep1
            cardType={cardType}
            getContextTranslate={this.getContextTranslate}
            handleAgreementCheckboxChange={handleAgreementCheckboxChange}
            hireCmsKey={hireCmsKey}
            immFlagBasedFeatures={immFlagBasedFeatures}
            hireCreditCard={hireCreditCard}
            immHireInformation={immHireInformation}
            immProfileFields={immProfile}
            requestPDFMerge={requestPDFMerge}
            sendMailParams={sendMailParams}
            setTermsAndCondsText={setTermsAndCondsText}
            showIneAndRevolving={showIneAndRevolving}
            collectiveLocation={collectiveLocation}
            newCardsFF={newCardsFF}
            contractPdfData={contractPdfData}
          />
        </ContactCenterRender>
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        nextButtonDisabled={nextButtonDisabledStep2}
        onBackClick={false}
        position="middle"
      >
        <HireCreditCardStep2
          cardType={cardType}
          getContextTranslate={this.getContextTranslate}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNameSelector={immHireCardNameSelector}
          hireCreditCard={hireCreditCard}
          getContextKeyTranslate={this.getContextKeyTranslate}
          extraImage={EXTRA_IMAGE}
        />
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        nextButtonDisabled={
          immHireCreditLimit.get('isFetching') ||
          immRevolvingPersistentData.get('isIframeError')
        }
        onBackClick={false}
        position="middle"
      >
        <HireCreditCardStep3
          getContextTranslate={this.getContextTranslate}
          handleAccountChange={this.handleAccountChange}
          immAccounts={immAccounts}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immGlobalVariables={immGlobalVariables}
          immHireCardImageSelector={immHireCardImageSelector}
          hireCreditCard={hireCreditCard}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
          setHireCreditLimit={setHireCreditLimit}
          toggleCreditLimitModal={toggleCreditLimitModal}
          validate={validate}
          setAllAccountsToInactive={setAllAccountsToInactive}
          creditType={this.getCardTypeString(cardType)}

        />
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        onBackClick={false}
        position="middle"
        nextButtonDisabled={isShippingAddressButtonDisabled || (isNewShippingAddress && !isNewShippingAddressButtonDisabled)}
      >
        <HireCreditCardStep4
          immHireContactData={immHireContactData}
          immShippingAddressList={immShippingAddressList}
          setShippingAddress={setShippingAddress}
          immFlagBasedFeatures={immFlagBasedFeatures}
          getInitCardsDocuments={getInitCardsDocuments}
        />
      </WizardStep>,
      <WizardStep
        addLoadingBehaviour
        cancelButton={true}
        immFinalButton={this.getContextTranslate('hire')}
        isLoading={hireCreditCard.get('isFetching')}
        onBackClick={false}
        position="last"
        officeSignature={isPrintOfficeMode()}
        finalButtonDisabled={newFinalButtonDisabledCC ? false : true}
      >
        <HireCreditCardStep5
          cardType={cardType}
          getContextTranslate={this.getContextTranslate}
          contractName="visa-open"
          handleAgreementCheckboxChange={handleAgreementCheckboxChange}
          immHireCardNameSelector={immHireCardNameSelector}
          hireCreditCard={hireCreditCard}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          immFlagBasedFeatures={immFlagBasedFeatures}
          immPdfData={immPdfData}
          immProfile={immShippingAddressList.get('shippingAddress')}
          immShippingAddressList={immShippingAddressList}
          operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_visaOpenNew" : undefined}
          requestPDFDownload={requestPDFDownload}
          sendMailParams={sendMailParams}
          sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
          setTermsAndCondsText={setTermsAndCondsText}
          showIneAndRevolving={showIneAndRevolving}
          onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
          hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
          cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
          hireCardNerudaPrintDocumentPolicy={hireCardNerudaPrintDocumentPolicy}
          hireCardNerudaPrintDocument={hireCardNerudaPrintDocument}
          printedAndSignedRadioChanged={printedAndSignedRadioChanged}
          enableButtonOffice={enableButtonOffice}
          checkRadioButtonPolicy={checkRadioButtonPolicy}
          documentsPrintedAndSigned={documentsPrintedAndSigned}
          processEmail={processEmail}
          placementIdCard={this.placementIdCard}
          serviceCodes={this.serviceCodes}
        />
      </WizardStep>
    ];

    const newSteps = (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
      ...commonSteps.slice(0, 4),
      __CONTACT_CENTER__ && !isPrintOfficeMode() || errorDir ?
        <WizardStep
          cancelButton={true}
          onBackClick={false}
          position="middle"
          nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
          immFlagBasedFeatures={immFlagBasedFeatures}
        >
          {this.buildINE()}
        </WizardStep> :
        <WizardStep
          cancelButton={true}
          onBackClick={false}
          position="middle"
          nextButtonDisabled={allDocumentRead}
          immFlagBasedFeatures={immFlagBasedFeatures}

        >
          {this.buildINEDIR()}
        </WizardStep>,
      ...commonSteps.slice(4)
    ] : commonSteps;

    return (
      <div>
        <div className="col-xs-12 col-md-8">
          <Wizard
            actions={wizardActions}
            immSteps={immSteps}
            showPreLeaveModal={showPreLeaveModal}
            stepsAmount={immSteps.size}
            wizardClass="hire-card-neruda__wizard"
            tealium={tealiumData[visibleStep - 1]}
            visibleStep={visibleStep}

            isTaggingSecondVersion
          >
            {newSteps}
          </Wizard>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="row">
            <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
              <HireCardSidebar
                hasShippingAddress={hasShippingAddress}
                immAccounts={immAccounts}
                immAddress={immShippingAddress}
                immGlobalVariables={immGlobalVariables}
                immHireCardImageSelector={immHireCardImageSelector}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCreditLimit={immHireCreditLimit}
                immHirePaymentMethod={immHirePaymentMethod}
                immShippingAddressList={immShippingAddressList}
                immProfile={immProfile}
                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                extraImage={EXTRA_IMAGE}
              />
            </div>
            <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
              <CallMeBack
                hasEntrance={false}
                context="contracts"
                modifier="contracts-view"
                pageTitle={formatText('breadcrumb-cards')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  hasCardOfType(type) {
    const { immCards } = this.props;
    const typeOfCard = `is${type}Card`;

    const hasCardOfType = immCards.getIn(['credit', 'byOrder']).some(cardId => {
      const immCard = immCards.getIn(['byId', cardId]);
      return immCard.get(typeOfCard) && immCard.get('status') === 'EN VIGOR';
    });

    return hasCardOfType;
  }

  render() {
    const { immAccounts, immCards, immFlagBasedFeatures, hireCreditCard, immProfile } =
      this.props;
    const pageTitle = getFinalTitle(this.getContextTranslate('pageTitle'));

    const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
    const isSecondStep = hireCreditCard.get('visibleStep') == WIZARD_SECOND_STEP;
    const isNerudaUser = immProfile.get('isNerudaUser');
    const creditCardsLimitExceed =
      immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) &&
      !isNerudaUser &&
      !hasAvailableCreditCards &&
      isSecondStep;
    let hasAvailableAccounts = true;
    if (__CONTACT_CENTER__) {
      hasAvailableAccounts = ownerFromAccount(immAccounts);
    }

    const mappingBreadcrumb = [
      {
        text: formatText('breadcrumb-cards'),
        url: '/myprofile/cards',
      },
      {
        text: formatText(this.getContextTranslate('breadcrumb')),
      },
    ];

    const processDetail = this.getProcessDetail();
    const hireRestrictionFlag = hireCreditCard.getIn([
      'steps',
      WIZARD_FIRST_STEP - 1,
      'hireRestriction',
    ]);
    const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

    let content;

    if (
      hireCreditCard.get('error') ||
      (__CONTACT_CENTER__ && !hasAvailableAccounts) ||
      creditCardsLimitExceed
    ) {
      content = (
        <div className="col-xs-12 col-md-offset-1 col-md-10">
          <HireCreditCardError
            getContextTranslate={this.getContextTranslate}
            hireCreditCard={hireCreditCard}
            hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
            maxAllowedNumberCards={creditCardsLimitExceed}
            processDetail={processDetail}
            getContextKeyTranslate={this.getContextKeyTranslate}
          />
        </div>
      );
    } else if (hireRestrictionFlag && hireRestrictionFF) {
      content = (
        <div className="col-xs-12 col-md-offset-1 col-md-10">
          <HireCreditCardError
            getContextTranslate={this.getContextTranslate}
            hireCreditCard={hireCreditCard}
            hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
            maxAllowedNumberCards={creditCardsLimitExceed}
            processDetail={processDetail}
            hireRestrictionFlag={hireRestrictionFlag}
            getContextKeyTranslate={this.getContextKeyTranslate}
          />
        </div>
      );
    } else if (hireCreditCard.get('submitSuccessful')) {

      content = this.buildSuccessful();
    } else {
      content = this.buildWizardHiringSteps();
    }
    return (
      <div className="hire-card-neruda">
        <div className="container-fluid">
          <div className="row">
            <OKCover size="medium" section="pg" customClass="col-xs-12">
              <OKHeaderSubPage breadcrumbConfig={mappingBreadcrumb} finalTitle={pageTitle} />
            </OKCover>
          </div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
            <div className="row grid-view--content-position-negative">{content}</div>

          </div>
        </div>
      </div>
    );
  }
}

HireCreditCardView.propTypes = {
  cardType: PropTypes.oneOf(['neruda', 'vanity', 'hormiguero', 'diamond']),
  getBlockedAccounts: PropTypes.func,
  getshippingAddressList: PropTypes.func,
  handleAccountChange: PropTypes.func.isRequired,
  handleAgreementCheckboxChange: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  immAccounts: PropTypes.object.isRequired,
  immCards: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object.isRequired,
  immGlobalVariables: PropTypes.object.isRequired,
  immHireCardImageSelector: PropTypes.object.isRequired,
  immHireCardNameSelector: PropTypes.object.isRequired,
  hireCreditCard: PropTypes.object.isRequired,
  immHireContactData: PropTypes.object.isRequired,
  immHireCreditLimit: PropTypes.object.isRequired,
  immHireInformation: PropTypes.object.isRequired,
  immHirePaymentMethod: PropTypes.object.isRequired,
  immProfile: PropTypes.object.isRequired,
  immPdfData: PropTypes.object.isRequired,
  immShippingAddressList: PropTypes.object,
  isNeruda: PropTypes.bool,
  location: PropTypes.object.isRequired,
  match: PropTypes.object,
  reset: PropTypes.func.isRequired,
  resetPrecontractualMail: PropTypes.func.isRequired,
  resetTermsAndCondsText: PropTypes.func.isRequired,
  requestPDFMerge: PropTypes.func.isRequired,
  requestPDFDownload: PropTypes.func.isRequired,
  resetBlockedAccounts: PropTypes.func,
  resetPrecontractualDocumentMail: PropTypes.func,
  sendPrecontractualDocumentMail: PropTypes.func.isRequired,
  setAllAccountsToInactive: PropTypes.func.isRequired,
  setDataNerudaCard: PropTypes.func.isRequired,
  setHireCreditLimit: PropTypes.func.isRequired,
  setShippingAddress: PropTypes.func,
  setTermsAndCondsText: PropTypes.func.isRequired,
  setVisibleStep: PropTypes.func.isRequired,
  setWillCancel: PropTypes.func.isRequired,
  toggleCreditLimitModal: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  validateStep: PropTypes.func.isRequired,
  immRevolvingPersistentData: PropTypes.func.object,
};

module.exports.constructor = HireCreditCardView;
module.exports.HireCreditCardView = connect(
  state => ({
    immAccounts: state.accounts,
    immCards: state.cards,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immGlobalVariables: state.globalVariables,
    immHireCardImageSelector: state.hireCardImageSelector,
    immHireCardNameSelector: state.hireCardNameSelector,
    hireCreditCard: state.hireCreditCard,
    immHireContactData: state.hireContactData,
    immHireCreditLimit: state.hireCreditLimit,
    immHireInformation: state.hireInformation,
    immHirePaymentMethod: state.hirePaymentMethod,
    immPdfData: state.precontractualsMergePdfs,
    immProfile: state.profile,
    immShippingAddressList: state.shippingAddress,
    immRevolvingPersistentData: state.revolvingPersistentData,
    immPrinter: state.printer,
  }),
  {
    getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
    getshippingAddressList: shippingAddressAction.getShippingAddressList,
    handleAccountChange: hireCreditCardActions.setAccount,
    handleAgreementCheckboxChange: hireCreditCardActions.setAgreementCheckbox,
    onHandleChangeCheckBoxCC: hireCreditCardActions.onHandleChangeCheckBoxCC,
    requestPDFDownload: mergePreContractualsPDF.downloadMergedPDF,
    requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
    reset: hireCreditCardActions.reset,
    resetPrintDocument: hireCreditCardActions.resetPrintDocument,
    resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
    resetPrecontractualDocumentMail:
      precontractualDocumentMailAction.resetPrecontractualDocumentMail,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetTermsAndCondsText: termsAndCondsInfoActions.reset,
    sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
    setAllAccountsToInactive: hireCreditCardActions.setAllAccountsToInactive,
    setDataNerudaCard: hireCreditCardActions.setDataNerudaCard,
    setHireCreditLimit: hireCreditCardActions.setHireCreditCardLimit,
    setShippingAddress: shippingAddressAction.setShippingAddress,
    setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
    setVisibleStep: hireCreditCardActions.setVisibleStep,
    setWillCancel: hireCreditCardActions.setWillCancel,
    toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
    validate: hireCreditCardActions.validate,
    validateStep: hireCreditCardActions.validateStep,
    cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
    cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
    checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
    printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
    enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
    checkRadioButton: hireCreditCardActions.checkRadioButton,
    checkRadioButtonPolicy: hireCreditCardActions.checkRadioButtonPolicy,
    checkRadioButtonIneDir: hireCreditCardActions.checkRadioButtonIneDir,
    hireCardNerudaPrintDocument: hireCreditCardActions.printDocument,
    hireCardNerudaPrintDocumentPolicy: hireCreditCardActions.printDocumentPolicy,
    myCardsTarjetasHire: hireCreditCardActions.myCardsTarjetasHire,
    getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
    processEmail: hireCreditCardActions.processEmail,
    resetEmailAndRadioButtonCC: hireCreditCardActions.resetEmailAndRadioButtonCC,
    documentRead: hireCreditCardActions.documentRead,
    onAcceptAllDocument: hireCreditCardActions.onAcceptAllDocument,
    saveDocumentList: hireCreditCardActions.saveDocumentList,
    setCardType: hireCreditCardActions.setCardType,


  }
)(withRouter(HireCreditCardView));
